// lib/proc.mjs のブラウザ代替。ブラウザ完結版では npm/vite 等の外部プロセスは動かせない。
// これらを必要とする経路（generate:treasures / validate:maps / build / npm ci）は backend 側で
// 呼び出さない設計。万一呼ばれたら「ブラウザでは実行不可」と明示して失敗させる（黙って握り潰さない）。
export async function runNpm() {
    throw new Error('ブラウザ完結版では npm/vite 等の外部プロセスは実行できません（この操作はローカル版ツールで行ってください）。');
}

export async function run() {
    throw new Error('ブラウザ完結版では外部プロセスは実行できません。');
}
